import { SmsStatistics } from "../../../hooks/apis/reports.api";
import { TbAlertCircle, TbCheck, TbClock, TbMessage, TbMessageCircle, TbMessageCircleDown, TbMessageCircleUp, TbMessageCircleX, TbSend, TbUserCheck, TbUserX } from "react-icons/tb";
import { Col } from "antd";
import { StaticCard } from "./StatisticCard";
import MultiCardCarousel from "../../MultiCardCarousel";

const MessageStatistics: React.FC<{ statistics: SmsStatistics | null }> = ({ statistics }) => {
    
    if (!statistics) {
        statistics = {
            total: 0,
            received: 0,
            delivered: 0,
            bulk_messages: 0,
            resolved: 0,
            unresolved: 0,
            failed: 0,
            pending: 0,
            read: 0,
            unread: 0,
            scheduled: 0,
            assigned: 0,
            unassigned: 0
        };
    }

    const statisticFields = [
        {
            title: "Total",
            icon: <TbMessageCircle color="white" size={30} />,
            className: "bnb2",
            value: statistics.total || 0
        },
        {
            title: "Received",
            icon: <TbMessageCircleDown size={30} />,
            className: "bnb2",
            value: statistics.received || 0
        },
        {
            title: "Sent",
            icon: <TbMessageCircleUp size={30} />,
            className: "bnb2",
            value: statistics.delivered || 0
        },
        {
            title: "Failed",
            icon: <TbMessageCircleX size={30} />,
            className: "redtext",
            value: statistics.failed || 0
        },
        {
            title: "Unread",
            icon: <TbMessage size={30} />,
            className: "bnb2",
            value: statistics?.unread || 0
        },
        {
            title: "Read",
            icon: <TbCheck size={30} />,
            className: "bnb2",
            value: statistics?.read || 0
        },
        {
            title: "Delivered",
            icon: <TbSend size={30} />,
            className: "bnb2",
            value: statistics?.delivered || 0
        },
        {
            title: "Pending",
            icon: <TbClock size={30} />,
            className: "bnb2",
            value: statistics?.pending || 0
        },
        {
            title: "Resolved",
            icon: <TbCheck size={30} />,
            className: "bnb2",
            value: statistics?.resolved || 0
        },
        {
            title: "Unresolved",
            icon: <TbAlertCircle size={30} />,
            className: "bnb2",
            value: statistics?.unresolved || 0
        },
        {
            title: "Assigned",
            icon: <TbUserCheck  size={30} />,
            className: "bnb2",
            value: statistics?.assigned || 0
        },
        {
            title: "Unassigned",
            icon: <TbUserX size={30} />,
            className: "bnb2",
            value: statistics?.unassigned || 0
        },
    ];
    return (
        <MultiCardCarousel>
            {statisticFields.map(field => (
                <Col key={field.title} style={{
                }} className="mb-24">
                    <StaticCard title={field.title} value={field.value} className={field.className} icon={field.icon} />
                </Col>
            ))}
        </MultiCardCarousel>
    );
};

export default MessageStatistics;
